/**
 * Performance Monitor
 * Safely tracks Core Web Vitals and performance metrics
 */

(function() {
  'use strict';
  
  // Wait for page to load
  window.addEventListener('load', function() {
    // Small delay to ensure all metrics are captured
    setTimeout(measurePerformance, 1000);
  });
  
  function measurePerformance() {
    try {
      // Core Web Vitals
      if ('PerformanceObserver' in window) {
        // LCP (Largest Contentful Paint)
        const lcpObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lastEntry = entries[entries.length - 1];
          console.log('LCP:', lastEntry.startTime);
          
          // Send to analytics if available
          if (window.gtag) {
            window.gtag('event', 'LCP', {
              value: Math.round(lastEntry.startTime),
              event_category: 'Web Vitals'
            });
          }
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
        
        // FID (First Input Delay)
        const fidObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach(entry => {
            console.log('FID:', entry.processingStart - entry.startTime);
            
            if (window.gtag) {
              window.gtag('event', 'FID', {
                value: Math.round(entry.processingStart - entry.startTime),
                event_category: 'Web Vitals'
              });
            }
          });
        });
        fidObserver.observe({ entryTypes: ['first-input'] });
        
        // CLS (Cumulative Layout Shift)
        let clsValue = 0;
        const clsObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach(entry => {
            if (!entry.hadRecentInput) {
              clsValue += entry.value;
            }
          });
          
          console.log('CLS:', clsValue);
          
          if (window.gtag) {
            window.gtag('event', 'CLS', {
              value: Math.round(clsValue * 1000) / 1000,
              event_category: 'Web Vitals'
            });
          }
        });
        clsObserver.observe({ entryTypes: ['layout-shift'] });
      }
      
      // Basic performance metrics
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation) {
        const metrics = {
          // DNS lookup time
          dns: navigation.domainLookupEnd - navigation.domainLookupStart,
          // TCP connection time
          tcp: navigation.connectEnd - navigation.connectStart,
          // First byte time
          ttfb: navigation.responseStart - navigation.requestStart,
          // DOM content loaded
          domContentLoaded: navigation.domContentLoadedEventEnd - navigation.navigationStart,
          // Page load time
          loadTime: navigation.loadEventEnd - navigation.navigationStart
        };
        
        console.log('Performance Metrics:', metrics);
        
        // Send to analytics
        if (window.gtag) {
          Object.entries(metrics).forEach(([key, value]) => {
            window.gtag('event', 'performance_metric', {
              metric_name: key,
              value: Math.round(value),
              event_category: 'Performance'
            });
          });
        }
      }
      
      // Resource timing
      const resources = performance.getEntriesByType('resource');
      const slowResources = resources.filter(resource => resource.duration > 1000);
      
      if (slowResources.length > 0) {
        console.log('Slow Resources:', slowResources);
        
        slowResources.forEach(resource => {
          if (window.gtag) {
            window.gtag('event', 'slow_resource', {
              resource_name: resource.name,
              duration: Math.round(resource.duration),
              event_category: 'Performance'
            });
          }
        });
      }
      
    } catch (error) {
      console.log('Performance monitoring error:', error);
    }
  }
  
  // Monitor for user interactions
  let interactionCount = 0;
  const interactionEvents = ['click', 'scroll', 'input', 'submit'];
  
  interactionEvents.forEach(eventType => {
    document.addEventListener(eventType, function() {
      interactionCount++;
      
      // Track interaction after 5 seconds
      if (interactionCount === 1) {
        setTimeout(() => {
          if (window.gtag) {
            window.gtag('event', 'user_interaction', {
              event_category: 'Engagement',
              value: interactionCount
            });
          }
        }, 5000);
      }
    }, { passive: true });
  });
  
  // Monitor for errors
  window.addEventListener('error', function(event) {
    if (window.gtag) {
      window.gtag('event', 'javascript_error', {
        event_category: 'Error',
        error_message: event.message,
        error_filename: event.filename,
        error_lineno: event.lineno
      });
    }
  });
  
  // Monitor for unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    if (window.gtag) {
      window.gtag('event', 'promise_rejection', {
        event_category: 'Error',
        error_message: event.reason
      });
    }
  });
  
})();
